import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ComercialRepository } from '../../repositories/comercial.repository';
import { ApiResponse } from '../../models/comercial/comercial-v1.model';
import { QuotationTaxModel } from '../../models/comercial/quotation-tax.model';
export class SaveQuotationTaxUseCase implements UseCase<QuotationTaxModel, ApiResponse<QuotationTaxModel>> {
  constructor(private repository: ComercialRepository) {}
  execute(params: QuotationTaxModel): Observable<ApiResponse<QuotationTaxModel>> { return this.repository.saveQuotationTax(params); }
}
